import React from "react";
import {Tooltip as ReactTooltip} from "react-tooltip";
import {formatValue} from "react-currency-input-field";

export const PriceBlockComponent = (props) => {

    const financial = (x) => Number.parseFloat(x).toFixed(0);

    return (
        <div className="">
            <div className="">
                <div className="lookup-card">
                    <div className="card-body rate-search-card">
                        {props.object.laneStatistics != undefined && props.object.laneStatistics != undefined &&
                            <div className={
                                props.object.laneStatistics != undefined && props.object.laneStatistics != undefined && props.object.laneStatistics.costPerMile.toString() == '0'
                                    ? "special-card"
                                    : "border-dark"
                            }
                            >
                                {(props.object.subscriptionType == 'Gold' || props.object.subscriptionType == 'Platinum') &&

                                    <ReactTooltip id="thirtyDaysAverage" multiline={true}/>
                                }

                                <a className="price-component-tool-tip" data-tooltip-id="thirtyDaysAverage"
                                   data-tooltip-html={
                                       // 'No.of.stops - low ' + props.object.laneStatistics.lowNumberOfStops + ' high ' + props.object.laneStatistics.highNumberOFStops + '<br/>' +
                                       '<i></i><em>low</em><u>high</u><br/>' +
                                       '<i># of stops</i><em>' + props.object.laneStatistics.lowNumberOfStops + '</em><u>' + props.object.laneStatistics.highNumberOFStops + '</u><br/>' +
                                       '<i>Lead time</i><em>' + props.object.laneStatistics.lowLeadTime + '</em><u>' + props.object.laneStatistics.highLeadTime + '</u><br/>' +
                                       '<i>Fuel surcharge</i><em>' + props.object.laneStatistics.lowFuelSurcharge + '</em><u>' + props.object.laneStatistics.highFuelSurcharge + '</u><br/>' +
                                       '<i>Lumper</i><em>' + props.object.laneStatistics.lowLumper + '</em><u>' + props.object.laneStatistics.highLumper + '</u><br/>' +
                                       '<i>Pallet charge</i><em>' + props.object.laneStatistics.lowPalletCharge + '</em><u>' + props.object.laneStatistics.highPalletCharge + '</u><br/>' +
                                       '<i>Weight ticket</i><em>' + props.object.laneStatistics.lowWeightTicket + '</em><u>' + props.object.laneStatistics.highWeightTicket + '</u><br/>' +
                                       '<i>Interchange</i><em>' + props.object.laneStatistics.lowInterchange + '</em><u>' + props.object.laneStatistics.highInterchange + '</u><br/>' +
                                       '<i>Container fee</i><em>' + props.object.laneStatistics.lowContainerFee + '</em><u>' + props.object.laneStatistics.highContainerFee + '</u><br/>' +
                                       '<i>Truck order</i><em>' + props.object.laneStatistics.lowTruckOrder + '</em><u>' + props.object.laneStatistics.highTruckOrder + '</u><br/>' +
                                       '<i>Unloading fees</i><em>' + props.object.laneStatistics.lowUnloadingFees + '</em><u>' + props.object.laneStatistics.highUnloadingFees + '</u><br/>' +
                                       '<i>Detention</i><em>' + props.object.laneStatistics.lowDetention + '</em><u>' + props.object.laneStatistics.highDetention + '</u><br/>'
                                   }>

                                    <small>Duration:</small>
                                    <p>{props.object.days}</p>

                                    <small>Cost per Mile:</small>
                                    <h6>
                                    	{formatValue({
                                        value: props.object.laneStatistics.costPerMile.toString(),
                                        intlConfig: {locale: 'en-US', currency: 'USD'},
                                        decimalScale: 2,
                                        suffix: '/mile'
                                    })}</h6>

                                    <small>Cost per Load:</small>
                                    <h6>
                                    	{formatValue({
                                        value: props.object.laneStatistics.averageLoadRate.toString(),
                                        intlConfig: {locale: 'en-US', currency: 'USD'},
                                        decimalScale: 0,
                                        suffix: '/load'
                                    })}
                                    </h6>
                                </a>
                                
                                <hr/>

                                <small>Average Load:</small>
                                <strong>{financial(props.object.laneStatistics.averageLoadMiles)} miles</strong>

                                <small>Avg. dist from req pick up: &nbsp; </small>
                                <strong>{financial(props.object.laneStatistics.averageDistanceFromRequestedPickup)}&nbsp;miles</strong>

                                <small>Avg. dist from req  drop off: &nbsp; </small>
                                <strong>{financial(props.object.laneStatistics.averageDistanceFromRequestedDrop)}&nbsp;miles</strong>

                            </div>}
						<br/>
                        <div className="">
                            {(props.object.subscriptionType == 'Gold' || props.object.subscriptionType == 'Platinum') &&
                                <button className="button__rates_list"
                                        onClick={props.object.onClick}>
                                    <span>{props.object.laneStatistics && props.object.laneStatistics.documentCount} reports</span>
                                </button>
                            }
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};
